// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"360":"5620ccefb566ae0f2bb2","475":"7e4dc22dc9fc0e79b3e9","483":"a9136fe1f968736e5102","634":"37e7f7f37f24d1f95905"}[chunkId] + ".chunk.js";
};